// extracted by mini-css-extract-plugin
export default {"header":"SportsBettingSearchResults_header__pxtA+"};